var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { useSafeFormData } from '../types/form';
export function useSuggestedSpaceQueryBase(_a) {
    var _b, _c, _d, _e, _f, _g;
    var enabled = _a.enabled, locationId = _a.locationId, levelId = _a.levelId;
    var form = useSafeFormData();
    var _h = __read(useState({ start: '', end: '' }), 2), debouncedRange = _h[0], setDebouncedRange = _h[1];
    var startIso = (_c = (_b = form === null || form === void 0 ? void 0 : form.startTime) === null || _b === void 0 ? void 0 : _b.toISOString()) !== null && _c !== void 0 ? _c : '';
    var endIso = (_e = (_d = form === null || form === void 0 ? void 0 : form.endTime) === null || _d === void 0 ? void 0 : _d.toISOString()) !== null && _e !== void 0 ? _e : '';
    useEffect(function () {
        var t = window.setTimeout(function () {
            setDebouncedRange({ start: startIso, end: endIso });
        }, 400);
        return function () { return window.clearTimeout(t); };
    }, [startIso, endIso]);
    var levelIdsForPreferences = useMemo(function () {
        if (!levelId)
            return null;
        return [levelId];
    }, [levelId]);
    var preferredSpaceCapacity = useMemo(function () {
        if (!form)
            return null;
        var withUser = form.invitees.filter(function (i) { return i.user_id; }).length;
        if (withUser > 0)
            return withUser;
        if (form.attendeeCount > 0)
            return form.attendeeCount;
        return null;
    }, [form]);
    var commonSkipReasons = !enabled ||
        !locationId ||
        !form ||
        form.isAllDayEvent ||
        !!form.recurrenceRule ||
        ((_g = (_f = form.spaces) === null || _f === void 0 ? void 0 : _f.length) !== null && _g !== void 0 ? _g : 0) > 0 ||
        !debouncedRange.start ||
        !debouncedRange.end ||
        moment(debouncedRange.end).isBefore(moment()) ||
        moment(debouncedRange.end).diff(moment(debouncedRange.start), 'minutes') <=
            0;
    return {
        debouncedRange: debouncedRange,
        levelIdsForPreferences: levelIdsForPreferences,
        preferredSpaceCapacity: preferredSpaceCapacity,
        commonSkipReasons: commonSkipReasons,
    };
}
